<template>
    <section class="dispatchOrder-table">
        <div class="dispatch-table-header">
            <el-button
                type="text"
                class="dispatch-refresh"
                icon="el-icon-refresh"
                @click="handleRefresh"
            >
                刷新
            </el-button>
        </div>
        <div v-loading="loading">
            <table-box
                ref="tablePage"
                :columns="config.table.columns"
                :height="config.table.height"
                :loading="loading"
                :rows="tableData"
                :actions="config.table.action"
            >
            </table-box>
            <m-page
                :current-page="currentPage"
                :pageData="config.page"
                :total="pageTotal"
                @on-page-change="pageChange"
                @on-size-change="sizeChange"
                class="page-container"
            ></m-page>
        </div>
    </section>
</template>
<script>
import tableBox from '@/components/lots/tableBox/Index.vue';
import mPage from '@/components/otpPanel/mPage';
import { dictWithUrl } from '@/components/lots/api.js';
import { viewDispatchIotPositionTracePage } from '@/modules/transport/otp/api/performanceDispatchMgmtNew.js';
import config from './config.js';
import { formatTotalDataList } from './util.js';

export default {
    name: 'dispatchLookOverTable',
    components: { tableBox, mPage },
    props: {
        componentsData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            config: config,
            loading: false,
            selected: [], // 选中数据
            tableData: [], // 列表数据
            page: {
                pageSize: 10,
                pageNo: 1
            },
            dictionaryCode: [
                'OTP_TYPE', // 类型
                'DEVICETYPE', // 设备类型
                'OTP_TRACKING_CHADAN_FLAG', // 是否推送查单系统
                'OTP_TRACKING_SOURCE', // 跟踪来源
                'OTP_TRACKING_WAY', // 跟踪方式
                'OTP_STATUS' // 网络和GPS
            ],
            dictData: {}, // 数据字典集合
            pageTotal: 0,
            currentPage: 1,
            componentsName: ''

        };
    },
    mounted () {
        this.getList();
    },
    methods: {
        /**
        * @getList 获取列表接口
        * @param {Object} searchParams 查询条件
        */
        async getList () {
            const dict = await dictWithUrl(this.dictionaryCode.join(','));
            this.dictData = dict.data;
            const obj = {
                pageNo: this.page.pageNo,
                pageSize: this.page.pageSize,
                param: {
                    dispatchNo: this.componentsData.dispatchNo
                }
            };
            this.loading = true;
            viewDispatchIotPositionTracePage(obj).then((res) => {
                if (res && +res.code === 0) {
                    this.tableData = formatTotalDataList(res.data.list, this.dictData);
                    this.page.pageNo = res.data.pageNo;
                    this.page.pageSize = res.data.pageSize;
                    this.pageTotal = res.data.totalCount;
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        /**
         * @description 刷新
        */
        handleRefresh () {
            this.page = {
                pageSize: 10,
                pageNo: 1
            };
            this.getList();
        },
        // 页数改变
        sizeChange (data) {
            this.page.pageSize = data;
            this.getList();
        },
        // 切分页
        pageChange (data) {
            this.page.pageNo = data;
            this.getList();
        },
        /**
         * @description 查询条件变化触发事件
         * @param {Object} data 查询条件
         */
        searchChange (data) {

        },
        selectChange (data) {
        },
        // 参数为空处理
        getSearchData (data) {
            const _searchData = {
                ...this.page,
                ...data,
                pageNo: 1
            };
            for (const key in _searchData) {
                if (_searchData[key] === '') delete _searchData[key];
            }
            return _searchData;
        }

    }
};
</script>

<style  lang="less" scoped>
.dispatchOrder-table {
    .mPane3-back-up .el-table {
        min-height: inherit;
    }
}
.dispatchOrder-table .model-table-search {
    display: none;
}
</style>
